module.exports = __webpack_public_path__ + "static/scale-model-of-japanese-tea-garden-in-san-antonio-texas-9c4aebf9e16565eb87e243f4ce60e854.png";